<div class="job-settings-container flex column">
  <div class="flex row header space-between align-items-baseline">
    <h3>{{ vm.headerTitle }}</h3>
    <evrideo-x-button (click)="vm.closeWindowAndGoBack()"></evrideo-x-button>
  </div>
  <div class="flex row">
    <div class="flex column fill-width margin-left-1vw margin-bottom-2vw">
      <div class="flex row">
        <h4>General</h4>
      </div>

      <div class="flex row field">
        <div class="title">Name</div>
        <div class="flex fill-width">
          <evrideo-simple-text-input
            [(value)]="vm.jobName"
            [disabled]="vm.editMode"
            [overrideStyle]="{
              'background-color': vm.editMode ? '#EAEAEA' : 'transparent',
            }"
            [placeholder]="'(optional) Enter Job Name'"
          ></evrideo-simple-text-input>
        </div>
      </div>
      <div class="flex row field" [hidden]="true">
        <div class="title">Priority Level</div>
        <div class="flex fill-width">
          <evrideo-priotiry-level [vm]="vm"></evrideo-priotiry-level>
        </div>
      </div>
      <div class="flex row field">
        <div class="title">Transcoding Profile</div>

        <div class="flex fill-width">
          <icn-dropdown
            [ngStyle]="{
              'background-color': vm.editMode ? '#EAEAEA' : 'transparent',
            }"
            [large]="true"
            [position]="'bottom'"
            [disabled]="vm.editMode"
            [placeholder]="'Select Transcoding Profile'"
            [(selectedValue)]="vm.selectedTranscodingProfile"
          >
            <!-- Render profiles based on selected type -->
            <ng-container
              *ngIf="
                vm.clusteredTranscodingProfiles.length === 0 ||
                vm.selectedProfileType === 'regular'
              "
            >
              <icn-dropdown-item
                *ngFor="let dest of vm.standaloneTranscodingProfiles"
                [title]="dest.title"
                [value]="dest.id"
              ></icn-dropdown-item>
            </ng-container>

            <ng-container
              *ngIf="
                vm.clusteredTranscodingProfiles.length > 0 &&
                vm.selectedProfileType === 'clustered'
              "
            >
              <icn-dropdown-item
                *ngFor="let dest of vm.clusteredTranscodingProfiles"
                [title]="dest.title"
                [value]="dest.id"
              ></icn-dropdown-item>
            </ng-container>

            <!-- Radio buttons for profile type selection - only show if clustered profiles exist -->
            <ng-container *ngIf="vm.clusteredTranscodingProfiles.length > 0">
              <div class="profile-type-selector" style="height: 20%">
                <div class="radio-button-group">
                  <button
                    type="button"
                    class="radio-button"
                    [class.active]="vm.selectedProfileType === 'regular'"
                    (click)="vm.selectProfileType('regular')"
                  >
                    Regular Profiles
                  </button>
                  <button
                    type="button"
                    class="radio-button"
                    [class.active]="vm.selectedProfileType === 'clustered'"
                    (click)="vm.selectProfileType('clustered')"
                  >
                    Super Profiles
                  </button>
                </div>
              </div>
            </ng-container>
          </icn-dropdown>
        </div>
      </div>
      <div class="flex row field">
        <div class="title">Transcoding Destination</div>
        <div class="flex fill-width">
          <icn-dropdown
            [large]="true"
            [disabled]="vm.editMode"
            [position]="'bottom'"
            [ngStyle]="{
              'background-color': vm.editMode ? '#EAEAEA' : 'transparent',
            }"
            [placeholder]="'Select Transcoding Destination'"
            [(selectedValue)]="vm.selectedTranscodingDestination"
          >
            <!--<icn-dropdown-item  [title]="'Select Transcoding Destination'" [value]="-1"></icn-dropdown-item>-->
            <icn-dropdown-item
              *ngFor="let dest of vm.allTranscodingDestinations"
              [title]="dest.title"
              [value]="dest.id"
            ></icn-dropdown-item>
          </icn-dropdown>
        </div>
      </div>
      <ng-container *ngIf="vm.allTranscodingSideEffects.length > 0">
        <div class="flex row field">
          <div class="title">Transcoding Side Effects</div>
          <div class="flex fill-width">
            <icn-dropdown
              [large]="true"
              [disabled]="vm.editMode"
              [position]="'bottom'"
              [ngStyle]="{
                'background-color': vm.editMode ? '#EAEAEA' : 'transparent',
              }"
              [placeholder]="'Select Transcoding Side Effect'"
              [(selectedValue)]="vm.selectedTranscodingSideEffect"
            >
              <icn-dropdown-item
                *ngFor="let sideEffect of vm.allTranscodingSideEffects"
                [title]="sideEffect.title"
                [value]="sideEffect.id"
              ></icn-dropdown-item>
            </icn-dropdown>
          </div>
        </div>
        <div class="flex row field">
          <div class="title"></div>
          <div class="flex fill-width">
            <evrideo-checkbox
              style="margin: 3px"
              (checked)="vm.executeOnlySideEffects = !vm.executeOnlySideEffects"
            ></evrideo-checkbox>
            <pre style="margin: 0">
Execute only side effects (this will not create any media transcoding job)</pre
            >
          </div>
        </div>
      </ng-container>
      <div class="flex row">
        <h3>Media Files</h3>
      </div>
      <div class="flex column fill-width">
        <!-- Tab Navigation -->
        <div class="flex row tab-navigation" *ngIf="vm.editMode === false">
          <button
            type="button"
            class="tab-button"
            [class.active]="vm.selectedMediaInputTab === 'drag'"
            (click)="vm.selectMediaInputTab('drag')"
          >
            Drag & Drop
          </button>
          <button
            *ngIf="vm.isSuperUser"
            type="button"
            class="tab-button"
            [class.active]="vm.selectedMediaInputTab === 'manual'"
            (click)="vm.selectMediaInputTab('manual')"
          >
            Manual Input
          </button>
        </div>

        <!-- Tab Content -->
        <div class="tab-content">
          <!-- Drag & Drop Tab -->
          <div
            *ngIf="vm.editMode === true || vm.selectedMediaInputTab === 'drag'"
            class="tab-panel"
          >
            <evrideo-media-files-landzone
              [ngStyle]="{
                'border-color': vm.showRedBorderOnMediaFilesLandzone
                  ? 'red'
                  : '',
              }"
              [vm]="vm"
            ></evrideo-media-files-landzone>
            <div *ngIf="vm.editMode === false" class="lading-zone-description">
              Drag media items from the MAM
            </div>
          </div>

          <!-- Manual Input Tab -->
          <div
            *ngIf="
              vm.editMode === false && vm.selectedMediaInputTab === 'manual'
            "
            class="tab-panel"
          >
            <div class="flex column fill-width">
              <div class="flex row field">
                <div class="title">Enter Media IDs manually:</div>
              </div>
              <div class="flex fill-width">
                <textarea
                  [(ngModel)]="vm.manualMediaIdsInput"
                  [placeholder]="
                    'Enter media IDs, one per line:\n1000000001\n1000000002\n1000000003'
                  "
                  rows="6"
                  style="
                    width: 100%;
                    padding: 10px;
                    border: 1px solid #e1e6eb;
                    border-radius: 4px;
                    font-family: monospace;
                    resize: vertical;
                  "
                ></textarea>
              </div>
              <div class="flex row margin-top-0-5vw">
                <small style="color: #666">
                  Enter one media ID per line. These will be used if no media
                  items are dragged from MAM.
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="flex column fill-width margin-left-1vw margin-bottom-1vw margin-right-1vw"
    >
      <h1
        class="flex column space-around align-items-center fill-height"
        *ngIf="
          vm.selectedMediaItem &&
          !(
            (vm.selectedItemPreviewUrl | async) &&
            (vm.selectedMediaInfo | async)
          )
        "
      >
        Loading...
      </h1>

      <ng-container
        *ngIf="(vm.selectedItemPreviewUrl | async) && vm.selectedMediaItem"
      >
        <div class="flex row blue">
          <video-container
            *ngIf="vm.selectedMediaInfo | async"
            [media]="vm.selectedMediaInfo | async"
            [subtitles]="(vm.selectedMediaInfo | async)?.subtitles"
            [audio]="(vm.selectedMediaInfo | async)?.audioFiles"
            [posterUrl]="(vm.selectedMediaInfo | async)?.contentSnapshotUrl"
            [videoUrl]="vm.selectedItemPreviewUrl | async"
            [framerate]="(vm.selectedMediaInfo | async)?.contentFps || 0"
            [showTrimBrackets]="true"
            [(trimInMs)]="vm.selectedMediaItem.mediaIn"
            [(trimOutMs)]="vm.selectedMediaItem.mediaOut"
            [mediaDurationMs]="vm.selectedMediaItem.durationMs"
          ></video-container>
        </div>
        <div class="flex row space-between field">
          <div>
            <b>{{ vm.selectedMediaItem.videoTitle }}</b>
          </div>
          <div>
            <evrideo-hover-button
              [width]="'140px'"
              [backgroundColor]="'#DDE3E7'"
              (click)="vm.selectedMediaItem.resetTrimming()"
            >
              <span>Clear Selection</span>
            </evrideo-hover-button>
          </div>
        </div>
        <div class="flex row field trim-fields" *ngIf="vm.selectedMediaItem">
          <div class="flex column">
            Trim In:<evrideo-time-editor
              [(valueMs)]="vm.selectedMediaItem.mediaIn"
              [minMs]="0"
              [maxMs]="vm.selectedMediaItem.mediaOut"
              [type]="'FPS'"
            ></evrideo-time-editor>
          </div>
          <div class="flex column">
            Trim Out:<evrideo-time-editor
              [(valueMs)]="vm.selectedMediaItem.mediaOut"
              [minMs]="vm.selectedMediaItem.mediaIn"
              [maxMs]="vm.selectedMediaItem.durationMs"
              [type]="'FPS'"
            ></evrideo-time-editor>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
  <div class="flex row footer justify-end">
    <evrideo-hover-button
      class="abort-btn"
      *ngIf="vm.editMode"
      [backgroundColor]="'white'"
      [hoverClass]="'transparent'"
      [color]="'black'"
      [border]="'1px solid black'"
      (click)="vm.abortJobClicked($event)"
    >
      <span>ABORT</span>
    </evrideo-hover-button>

    <evrideo-hover-button (click)="vm.applyClicked($event)">
      <span class="btn-text">APPLY</span>
    </evrideo-hover-button>
  </div>
</div>
